// Key codes
export const W = 'w'
export const A = 'a'
export const S = 's'
export const D = 'd'
export const Z = 'z'  // For AZERTY keyboards (forward)
export const Q = 'q'  // For AZERTY keyboards (left)
export const SHIFT = 'shift'
export const DIRECTIONS = [W, A, S, D, Z, Q]

// Animation states
export const IDLE = 'Idle'
export const WALK = 'Walk'
export const RUN = 'Run'